import { BrandAdTokenValue } from "../../../models/brand.model.ts";
import { httpRequest } from "../../http";

export const brandAdTokenValuesUrl = (organizationId: string, brandId: string) =>
    `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${organizationId}/brands/${brandId}/ad-token-values/`;

/** The brand's live ad token values. */
export class CommandGetBrandAdTokenValues {
    async run(organizationId: string, brandId: string): Promise<BrandAdTokenValue[]> {
        return await httpRequest<BrandAdTokenValue[]>(brandAdTokenValuesUrl(organizationId, brandId), { method: "GET" });
    }
}
